'use strict';

import template from '../../templates/mppAccounts/Account.ejs';
import loader from 'helpers/loader';
import modal from 'helpers/modal';

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {
        'click .js-invoice': 'invoice',
        'click .js-change-mpp-logo': 'onChangeLogo',
        'click .js-remove-mpp-logo': 'onRemoveLogo',
        'change .js-change-mpp-logo-input':  'uploadLogo',
        'change select[name=mppPlan]': 'updatePlan',
        'change input[name=discount]': 'updateDiscount'
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            discountCodes: []
        });

        this.model.on('sync', this.render, this);
        this.model.fetchSubscription().then(() => this.render());
        return this;
    },

    render() {
        this.$el.html(template({
            model: this.model,
            subscription: this.model.getSubscription(),
            mppPlans: [
                {id: 'mpp', name: 'Regular'},
                {id: 'bronze', name: 'Bronze'},
                {id: 'silver', name: 'Silver'},
                {id: 'gold', name: 'Gold'},
                {id: 'platinum', name: 'Platinum'}
            ],
            discountCodes: this.options.discountCodes
        }));

        this.$el.find('.company-logo')
            .on('load', (e) => {
                $(e.target.parentElement).removeClass('hidden');
                this.$('.js-remove-mpp-logo').removeClass('hidden');
                this.$('.js-change-mpp-logo').text('Change Logo');
            });

        return this;
    },

    invoice(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.getSubscription().generateInvoices()
            .then(stopLoader)
            .catch(err => {
                stopLoader();
                modal.showError(`Error: ${JSON.stringify(err)}`, false);
            });
    },

    updatePlan(ev) {
        ev.preventDefault();
        const $input = this.$(ev.currentTarget);
        const plan = $input.val();
        const stopLoader = loader.startFullScreen();
        this.model.getSubscription().setPlan(plan)
            .then(() => this.render())
            .then(() => {
                modal.showAlertSuccess('The plan has been updated');
                this.$('[name="discount"]').prop('disabled', plan !== 'mpp');
            })
            .catch(err => modal.showError(JSON.stringify(err)))
            .finally(stopLoader);
    },

    updateDiscount(ev) {
        ev.preventDefault();
        const $input = this.$(ev.currentTarget);
        const discountName = $input.val();
        const stopLoader = loader.startFullScreen();
        const subscription = this.model.getSubscription();

        if (!discountName) {
            subscription.set({
                couponCode: ''
            });
        } else {
            const discountCode = this.options.discountCodes
                .find(code => [
                    // jscs:disable
                    code.invoice_name, code.name
                ].includes(discountName));

            if (!discountCode) {
                modal.warning({
                    text: `Invalid discount specified. Please choose \
                    from the dropdown list`
                });
                return stopLoader();
            }

            subscription.set({
                couponCode: discountCode.id
            });
        }

        return subscription.save()
            .then(() => this.render())
            .then(() => {
                modal.showAlertSuccess('The discount has been updated');
            })
            .catch(err => modal.showError(JSON.stringify(err)))
            .finally(stopLoader);
    },

    onChangeLogo: function() {
        this.$('.js-change-mpp-logo-input').click();
    },

    onRemoveLogo: function(ev) {
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        this.model.removeLogo()
            .then(() => this.render())
            .catch(err => modal.showError(JSON.stringify(err), false))
            .finally(() => stopLoader());
    },

    uploadLogo: function(ev) {
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        const selectedFile = this.$(ev.currentTarget)[0].files[0];
        this.model.uploadLogo(selectedFile)
            .then(() => this.render())
            .catch(err => modal.showError(JSON.stringify(err), false))
            .finally(() => stopLoader());
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/mppAccounts/Account.js